import { useLocation } from "react-router-dom"
import { useMemo } from "react"

const useParam = (key: string): string | null => {
    const { search } = useLocation()

    const value = useMemo(() => {
        const params = new URLSearchParams(search)
        return params.get(key)
    }, [search, key])

    return value
}

export default useParam
